// /home/Hakyury/sites/eight-percent.com/frontend/src/App.js
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React from "react";
import Home from "./component/Home";
import Header from "./component/Header";
import Footer from "./component/Footer";
import { initAuthTimers } from "./utils/authFetch";

function App() {
  // Инициализируем таймеры обновления токенов
  React.useEffect(() => {
    initAuthTimers();
  }, []);

  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;